/**
 * Chat details sheet subtitle copy.
 *
 * Count copy agrees with its number (ISSUE-773): "1 member" for one, "N members"
 * for zero, two, or more. This helper reuses memberCountLabel from the pools
 * list so the two features never disagree on how to count members (ISSUE-1182).
 */

import { memberCountLabel } from "../pools/poolsListState";

export function chatDetailsSubtitle(memberCount: number): string {
  return `Chat · ${memberCountLabel(memberCount)}`;
}

/**
 * ISSUE-1363. "Delete chat" on a private chat removes it for the viewer only.
 * The confirm names who keeps their copy and what brings it back.
 */
export const DELETE_CHAT_FOR_ME_LABEL = "Delete chat";

export function deleteChatForMeConfirmTitle(): string {
  return "Delete this chat?";
}

export function deleteChatForMeConfirmBody(otherName: string): string {
  return `It leaves your list and its messages are gone for you. ${otherName} keeps their copy. If they write again, the chat comes back with just the new messages.`;
}
